import { createMachine } from '@/lib/stateMachine';

export const CONTROL_STATUSES = {
  DRAFT: { label: 'Draft', color: 'gray' },
  REVIEWING: { label: 'Reviewing', color: 'blue' },
  APPROVED: { label: 'Approved', color: 'teal' },
  REJECTED: { label: 'Rejected', color: 'red' },
  RETURNED: { label: 'Returned', color: 'yellow' },
  RELEASED: { label: 'Released', color: 'green' },
};

export const controlMachineConfig = {
  initial: 'DRAFT',
  reviewGroupOrder: ['processOwners', 'qmrQa', 'managementApprovers'],
  states: {
    DRAFT: {
      actions: {
        submit: { next: 'REVIEWING', actorRule: 'creator' },
        edit: { next: null, actorRule: 'creator' },
        delete: { next: null, actorRule: 'creator' },
      },
    },
    REVIEWING: {
      actions: {
        approve: { next: 'dynamic', actorRule: 'pipeline' },
        reject: { next: 'REJECTED', actorRule: 'pipeline', resetIndex: true },
        returnToRequestor: { next: 'RETURNED', actorRule: 'pipeline', resetIndex: true },
      },
    },
    RETURNED: {
      actions: {
        edit: { next: null, actorRule: 'creator' },
        submit: { next: 'REVIEWING', actorRule: 'creator', resetIndex: true },
      },
    },
    APPROVED: {
      actions: {
        release: { next: 'RELEASED', actorRule: 'role', requiredRole: ['QA'] },
      },
    },
    RELEASED: {
      actions: {}, // terminal state — no further transitions
    },
    REJECTED: {
      actions: {}, // terminal state — only visible to QA
    },
  },
};

export const controlMachine = createMachine(controlMachineConfig);
